module.exports = __webpack_public_path__ + "static/media/CP MAC Seguro de Robo Equipos.9c9eafb7.pdf";